import { useRouteError } from '@wirechunk/ui';
import type { FunctionComponent } from 'react';

// See https://github.com/remix-run/react-router/discussions/10166
// All top-level routes should have this set as the error boundary.
export const RethrowErrorBoundary: FunctionComponent = () => {
  throw useRouteError();
};
